"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var online_drivers_ed_success_controller_1 = __importDefault(require("./online-drivers-ed-success.controller"));
var online_drivers_ed_success_html_1 = __importDefault(require("./online-drivers-ed-success.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.onlinedriversedsuccess", {
        url: "/online-drivers-ed-success",
        controller: online_drivers_ed_success_controller_1.default,
        controllerAs: "vm",
        template: online_drivers_ed_success_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.onlinedrivesedsuccess", [])
    .config(config)
    .controller("StudentOnlineDriversEdSuccessController", online_drivers_ed_success_controller_1.default);
